export default "__VITE_ASSET__7e7e6a2c__"